import * as types from '../actions/public/types';


const INITIAL_STATE = {};

export default function publicReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.GET_PRACTICE_DETAILS:

      return action.payload;

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/publicReducer.js